import Vue from "vue";
import VueRouter from "vue-router";
import Main from "../views/Main";
import Navbar from "@/components/Navbar";
// import BottomNavigation from "@/components/BottomNavigation";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Main",
    components: { default: Main, navbar: Navbar },
    props: {
      navbar: {
        darkNav: true
      }
    }
  },
  {
    path: "/friends",
    name: "Friends",
    components: { default: () => import("../views/Friends"), navbar: Navbar },
    props: {
      navbar: {
        darkNav: false
      }
    }
  },
  {
    path: "/lectors",
    name: "Lectors",
    components: { default: () => import("../views/Lectors"), navbar: Navbar },
    props: {
      navbar: {
        darkNav: false
      }
    }
  },
  {
    path: "/lector/:id",
    name: "Lector",
    components: { default: () => import("../views/Lector"), navbar: Navbar },
    props: {
      navbar: {
        darkNav: false
      }
    }
  },
  {
    path: "/team",
    name: "Team",
    components: { default: () => import("../views/Team"), navbar: Navbar },
    props: {
      navbar: {
        darkNav: false
      }
    }
  },
  // {
  //   path: "/price",
  //   name: "Price",
  //   components: { default: () => import("../views/Price"), navbar: Navbar },
  //   props: {
  //     navbar: {
  //       darkNav: false
  //     }
  //   }
  // },
  // {
  //   path: "/transfer",
  //   name: "Transfer",
  //   components: {
  //     default: () => import("../views/Transfer.vue"),
  //     navbar: Navbar
  //   },
  //   props: {
  //     navbar: {
  //       darkNav: false
  //     }
  //   }
  // },
  {
    path: "/volunteer/:id",
    name: "Volunteer",
    components: { default: () => import("../views/Volunteer"), navbar: Navbar },
    props: {
      navbar: {
        darkNav: false
      }
    }
  },
  {
    path: "/help",
    name: "Help",
    components: { default: () => import("../views/Help"), navbar: Navbar },
    props: {
      navbar: {
        darkNav: false
      }
    }
  },
  {
    path: "/donate-confirmation",
    name: "DonateConfirmation",
    components: {
      default: () => import("../views/DonateConfirmation.vue"),
      navbar: Navbar
    },
    props: {
      navbar: {
        darkNav: false
      }
    }
  },
  {
    path: "/contacts",
    name: "Contacts",
    components: { default: () => import("../views/Contacts"), navbar: Navbar },
    props: {
      navbar: {
        darkNav: false
      }
    }
  },
  {
    path: "/principes",
    name: "Principes",
    components: {
      default: () => import("../views/Principes"),
      navbar: Navbar
    },
    props: {
      navbar: {
        darkNav: false
      }
    }
  },
  // {
  //   path: "/program",
  //   name: "Program",
  //   components: {
  //     default: () => import("../views/MainPage/Schedule"),
  //     navbar: Navbar
  //   },
  //   props: {
  //     navbar: {
  //       darkNav: false
  //     }
  //   }
  // },
  // {
  //   path: "/evening-program",
  //   name: "Evening",
  //   components: {
  //     default: () => import("../views/EveningProgram"),
  //     navbar: Navbar
  //   },
  //   props: {
  //     navbar: {
  //       darkNav: false
  //     }
  //   }
  // },
  // {
  //   path: "/children-program",
  //   name: "Children",
  //   components: {
  //     default: () => import("../views/ChildrenProgram"),
  //     navbar: Navbar
  //   },
  //   props: {
  //     navbar: {
  //       darkNav: false
  //     }
  //   }
  // },
  {
    path: "/register",
    name: "Register",
    components: { default: () => import("../views/Register"), navbar: Navbar },
    props: {
      navbar: {
        darkNav: false
      }
    }
  },
  {
    path: "/registration-confirmation",
    name: "RegistrationConfirmation",
    components: {
      default: () => import("../views/RegistrationConfirmation"),
      navbar: Navbar
    },
    props: {
      navbar: {
        darkNav: false
      }
    }
  },
  {
    path: "/registration-payments",
    name: "RegistrationPayments",
    components: {
      default: () => import("../views/RegistrationPayments"),
      navbar: Navbar
    },
    props: {
      navbar: {
        darkNav: false
      }
    }
  },
  // {
  //   path: "/market-register",
  //   name: "MarketRegister",
  //   components: {
  //     default: () => import("../views/MarketRegister"),
  //     navbar: Navbar
  //   },
  //   props: {
  //     navbar: {
  //       darkNav: false
  //     }
  //   }
  // },
  // {
  //   path: "/brunch-register",
  //   name: "Brunch",
  //   components: {
  //     default: () => import("../views/BrunchRegister"),
  //     navbar: Navbar
  //   },
  //   props: {
  //     navbar: {
  //       darkNav: false
  //     }
  //   }
  // },
  // {
  //   path: "/market-register",
  //   name: "MarketRegister",
  //   components: {
  //     default: () => import("../views/MarketRegister"),
  //     navbar: Navbar
  //   },
  //   props: {
  //     navbar: {
  //       darkNav: false
  //     }
  //   }
  // },
  // {
  //   path: "/brunch-register",
  //   name: "Brunch",
  //   components: {
  //     default: () => import("../views/BrunchRegister"),
  //     navbar: Navbar
  //   },
  //   props: {
  //     navbar: {
  //       darkNav: false
  //     }
  //   }
  // },
  // {
  //   path: "/archive/:slug",
  //   name: "Archive",
  //   components: {
  //     default: () => import("../views/archive-page/ArchivePage.vue"),
  //     navbar: Navbar
  //   },
  //   props: {
  //     navbar: {
  //       darkNav: false
  //     }
  //   }
  // },
  {
    path: "/book",
    name: "Book",
    components: { default: () => import("../views/Book"), navbar: Navbar },
    props: {
      navbar: {
        darkNav: false
      }
    }
  },
  {
    path: "/events/:slug",
    name: "EventDetailsForm",
    components: {
      default: () => import("../views/event-page/EventDetailsFormPage.vue"),
      navbar: Navbar
    },
    props: {
      navbar: {
        darkNav: false
      }
    }
  },
  {
    path: "/events/:slug/confirmation",
    name: "EventDetailsConfirmation",
    components: {
      default: () =>
        import("../views/event-page/EventDetailsConfirmationPage.vue"),
      navbar: Navbar
    },
    props: {
      navbar: {
        darkNav: false
      }
    }
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import("../views/NotFound")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    // eslint-disable-next-line no-unused-vars
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0, behavior: "smooth" });
      }, 500);
    });
  }
});

export default router;
